function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { postSubscribe } from '@cbhq/cdx-api';
import { useDeploymentTargetContext, HeroPrimary as HeroPrimary$1 } from '@cbhq/cdx-components';
import { mapEntryLink } from '../globals/navlink.js';
import { MEDIA_TYPE_MAP, LAYOUT_MAP, IMAGE_FIT_MAP, CONTENTFUL_COMPONENTS_STYLE_MAP } from './contentToPropsMap.js';
import { jsx } from 'react/jsx-runtime';
const HERO_PRIMARY_CONTENT_MODEL_ID = 'cdxHeroPrimary5050';
function HeroPrimary({
  headline,
  excerpt,
  media,
  layout,
  eyebrow,
  imageFit,
  legalText,
  ctaButtonUrl,
  ctaButtonLabel,
  primaryLink,
  link: secondaryLink,
  list,
  style,
  subhead,
  anchor,
  videoUrl,
  lottiLoop,
  lottiType,
  hasEyebrowIcon,
  mediaType: mediaTypeProp,
  hasLightbox,
  ctaType,
  formSettings,
  thumbnail,
  logos = []
}) {
  const primaryNavLink = primaryLink && mapEntryLink(primaryLink);
  const secondaryNavLink = secondaryLink && mapEntryLink(secondaryLink);
  const mediaType = mediaTypeProp && MEDIA_TYPE_MAP[mediaTypeProp];
  const mediaUrl = mediaType === 'video' ? videoUrl : media?.fields.file?.url;
  const _ref = formSettings?.fields || {},
    submitButtonLabel = _ref.submitButtonLabel,
    productId = _ref.productId,
    placeholder = _ref.placeholder,
    successMessage = _ref.successMessage;
  const logosList = logos.map(logo => ({
    label: logo.fields.label,
    imageUrl: logo.fields.image?.fields.file?.url,
    title: logo.fields.title
  }));
  const _useDeploymentTargetC = useDeploymentTargetContext(),
    deploymentTargetName = _useDeploymentTargetC.deploymentTargetName;

  // TODO: handle locale
  const _country$localeCode$c = {
      country: 'US',
      localeCode: 'en',
      currency: 'USD'
    },
    country = _country$localeCode$c.country,
    localeCode = _country$localeCode$c.localeCode,
    currency = _country$localeCode$c.currency;
  const onSubmit = async email => {
    if (!productId) return false;
    const result = await postSubscribe({
      email,
      countryCode: country,
      locale: localeCode,
      currency,
      productId,
      isProd: deploymentTargetName === 'production'
    });

    // TODO: log event

    return result;
  };
  const defaultProps = {
    list,
    anchor,
    hasEyebrowIcon,
    eyebrow,
    headline,
    mediaUrl,
    mediaType,
    legalText,
    lottiLoop,
    lottieType: lottiType,
    excerpt: excerpt || subhead,
    layout: LAYOUT_MAP[layout],
    hasLightbox,
    mediaAlt: media?.fields.title,
    imageFit: imageFit && IMAGE_FIT_MAP[imageFit],
    style: CONTENTFUL_COMPONENTS_STYLE_MAP[style],
    thumbnailUrl: thumbnail?.fields.file?.url,
    thumbnailAlt: thumbnail?.fields.title,
    logos: logosList
  };
  if (ctaType === 'form') {
    return /*#__PURE__*/jsx(HeroPrimary$1, _objectSpread(_objectSpread({}, defaultProps), {}, {
      ctaType: "form",
      submitButtonLabel: submitButtonLabel,
      placeholder: placeholder,
      successMessage: successMessage,
      onSubmit: onSubmit
    }));
  }
  return /*#__PURE__*/jsx(HeroPrimary$1, _objectSpread(_objectSpread({}, defaultProps), {}, {
    ctaButtonUrl: primaryNavLink?.url || ctaButtonUrl,
    ctaButtonLabel: primaryNavLink?.label || ctaButtonLabel,
    secondaryButtonUrl: secondaryNavLink?.url,
    secondaryButtonLabel: secondaryNavLink?.label
  }));
}
export { HERO_PRIMARY_CONTENT_MODEL_ID, HeroPrimary };
//# sourceMappingURL=HeroPrimary.js.map
